import React from 'react';
import { Container, Row, Col, Nav } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

const Footer = () => {
    return (
        <div className='foo' color='light'>
        <footer className="footer">
        <Container>
          <p>Copyright 2010 Brave Fox. All rights reserved.</p>
        </Container>
      </footer>
      </div>
    );
  }
  
  export default Footer;
  